export default "__VITE_ASSET__DhI_pPnR__"